import { Mutation, ActionContext, Getter } from 'vuex'
import {
    SET_CODES,
} from "../constants/const";
interface CodesState {
    codes: Array<Object>;
}

interface CodesMutation {
    [mutationType: string]: Mutation<CodesState>;
}

interface CodesActions {
    [actionType: string]: (injectee: ActionContext<CodesState, any>, payload: any) => void;
}

interface CodesGetter {
    [getter: string]: Getter<CodesState, any>;
}

const state: CodesState = {
    codes: [],
}

const mutations: CodesMutation = {
    [SET_CODES](state: CodesState, newState: Array<any>): void {
        state.codes = newState;
    },
}

const actions: CodesActions = {
    [SET_CODES](context: { [prop: string]: any }, newName: string): void {
        context.commit(SET_CODES, newName)
    },
}

const getters: CodesGetter = {
    getCodes: (state: CodesState) => {
        return state.codes
    },
}

export default {
    namespace: true,
    state,
    mutations,
    actions,
    getters
}